import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import RecipeBuilder from "./RecipeBuilder";
// import StockInfo from "./StockInfo";

class RecipeConfigModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ingredients: [],
      stock_quantity: "",
      stock_cost_price: "",
    };
  }

  componentDidMount() {
    if (this.props.data) {
      this.parseData(this.props.data);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data && this.props.data) {
      this.parseData(this.props.data);
    }
  }

  parseData = (data) => {
    this.setState({
      ingredients: data.ingredients || [],
      stock_quantity: data.stock_quantity || "",
      stock_cost_price: data.stock_cost_price || "",
    });
  };

  handleIngredientsChange = (ingredients) => {
    this.setState({ ingredients });
  };

  handleQuantityChange = (val) => {
    this.setState({ stock_quantity: val });
  };

  handleCostPriceChange = (val) => {
    this.setState({ stock_cost_price: val });
  };

  handleSave = () => {
    const { ingredients, stock_quantity, stock_cost_price } = this.state;
    this.props.onSave({
      ingredients,
      stock_quantity,
      stock_cost_price,
    });
    this.props.toggle();
  };

  render() {
    const { isOpen, toggle, business_type, data_stocks, sellingPrice } =
      this.props;
    const { ingredients, stock_quantity, stock_cost_price } = this.state;
    const isFnB = business_type === "cafe" || business_type === "restaurant";

    return (
      <>
        <style>
          {`
            .modal-custom-wide {
              max-width: 95% !important;
              width: 95% !important;
              margin-left: auto !important;
              margin-right: auto !important;
            }
            @media (min-width: 992px) {
              .modal-custom-wide {
                max-width: 60% !important;
                width: 60% !important;
              }
            }
          `}
        </style>
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          className="modal-custom-wide"
          backdrop="static"
        >
          <ModalHeader toggle={toggle}>Định lượng & Tồn kho</ModalHeader>
          <ModalBody>
            <RecipeBuilder
              ingredients={ingredients}
              data_stocks={data_stocks || []}
              onCreateStock={this.props.onCreateStock}
              onChange={this.handleIngredientsChange}
              disabled={false}
              sellingPrice={sellingPrice || 0}
              data_providers={this.props.data_providers || []}
              business_type={business_type}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Hủy
            </Button>
            <Button color="primary" onClick={this.handleSave}>
              Lưu
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default RecipeConfigModal;
